import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import {
    Card, CardContent, CardHeader, IconButton,
    Table, TableBody, TableCell, TableRow, Hidden
} from '@material-ui/core';

import { NumberSpinner } from '../../../components/InputControls'
import { withRouter } from 'react-router'
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px"
    }
}));

const DonationProductCard = props => {

    const { products } = props;
    const [errorMsg, seterrorMsg] = useState("");
    const classes = useStyles();

    const removeclickhandler = (ProductID) => {
        props.removeclickhandler(ProductID);
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const getTotalAmount = () => {
        let amount = {
            total: 0
        }

        products.forEach(product => {
            amount.total += product.Amount;
        });

        return amount;
    }

    return (
        <Card
            className={classes.root}
        >
            <CardHeader className={classes.tourheaderbox}
                title={"Donations"}
                titleTypographyProps={{ color: "inherit" }}
            />
            <CardContent>
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Table size="small" className={classes.table} aria-label="spanning table">
                    <TableBody>
                        {products.map(ticket => (
                            <TableRow key={ticket.ProductID}>
                                <TableCell className={classes.tablecell} align="left">
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => removeclickhandler(ticket.ProductID)}
                                    >
                                        <CancelIcon color={"error"} />
                                    </IconButton>
                                </TableCell>
                                <TableCell className={classes.tablecell}>{ticket.ProductName}</TableCell>
                                <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(ticket.Amount)}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}></TableCell>
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">Total  {genfunction.ccyFormat(getTotalAmount().total)}</TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

DonationProductCard.propTypes = {
    products: PropTypes.array.isRequired,
    removeclickhandler: PropTypes.func
};

export default withRouter(DonationProductCard);
